/* global axios */
import ApiClient from './ApiClient';

class KanbanStagesAPI extends ApiClient {
  constructor() {
    super('kanban_pipelines', { accountScoped: true });
  }

  get(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/kanban_stages`);
  }

  create({ pipelineId, ...stageObj }) {
    return axios.post(`${this.url}/${pipelineId}/kanban_stages`, stageObj);
  }

  update({ pipelineId, id, ...stageObj }) {
    return axios.patch(
      `${this.url}/${pipelineId}/kanban_stages/${id}`,
      stageObj
    );
  }

  delete({ pipelineId, id }) {
    return axios.delete(`${this.url}/${pipelineId}/kanban_stages/${id}`);
  }

  reorder({ pipelineId, positionsHash }) {
    return axios.post(`${this.url}/${pipelineId}/kanban_stages/reorder`, {
      positions_hash: positionsHash,
    });
  }

  getConversations({ pipelineId, id, offset = 0 }) {
    return axios.get(
      `${this.url}/${pipelineId}/kanban_stages/${id}/conversations`,
      { params: { offset } }
    );
  }
}

export default new KanbanStagesAPI();
